export interface AppItem {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  /** Optional icon path under public assets (e.g. assets/images/visual-motivator-icon.png) */
  icon?: string;
  /** When set, the app card links to this URL (external) instead of /app/:slug */
  url?: string;
}

export const apps: AppItem[] = [
  {
    slug: 'visual-motivator',
    name: 'Visual Motivator',
    tagline: 'Daily quotes & personal visual board',
    description: 'Stay motivated with daily quotes and a visual board for your goals. Set reminders and optionally lock the app with Face ID or fingerprint.',
    icon: 'assets/images/visual-motivator-icon.png',
  },
  {
    slug: 'reap',
    name: 'Reap',
    tagline: 'IR & investor relations mobile app',
    description: 'Mobile app for investor relations: AI assistant, documents, events, and insights. Built with Expo, TypeScript, Node.js, Rust, AWS, and AI.',
    icon: 'assets/images/reap-icon.png',
    url: 'https://www.reapapp.io',
  },
];
